// extracted by mini-css-extract-plugin
export default {"business_advantages":"Advantages_business_advantages__sVQQA"};